import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils";

interface CheckboxProps extends CheckboxPrimitive.CheckboxProps { readonly className?: string; }

export function Checkbox({ className, ...props }: CheckboxProps): React.JSX.Element {
  return <CheckboxPrimitive.Root className={cn("flex size-5 shrink-0 items-center justify-center rounded-md border border-slate-300 bg-white text-white outline-none transition focus-visible:ring-2 focus-visible:ring-blue-600 data-[state=checked]:border-blue-600 data-[state=checked]:bg-blue-600", className)} {...props}><CheckboxPrimitive.Indicator><Check className="size-3.5" strokeWidth={3} /></CheckboxPrimitive.Indicator></CheckboxPrimitive.Root>;
}
